import React from 'react'
import { Translation } from '@morningtrain/react-translations'
import { useCollection } from '@morningtrain/react-resources'
import { useEnvValue } from '@morningtrain/react-helpers'
import { autorun } from 'mobx'

function ToggleAllCategories () {
  const collection = useCollection()

  const [allIds, setAllIds] = React.useState([])

  React.useEffect(() => {
    const disposer = autorun(() => {
      setAllIds(collection.map((category) => {
        return category.get('id')
      }))
    }, { fireImmediately: true })
    return () => {
      disposer()
    }
  }, [])

  const key = 'globals.inventory.supplier_categories'
  const [categories, setCategories] = useEnvValue(key, [])

  const [allChecked, setAllChecked] = React.useState(false)

  const toggle = (event) => {
    const isActive = event.target.checked

    const newCategories = {}

    if (isActive) {
      allIds.forEach((categoryId) => {
        newCategories[categoryId] = categories[categoryId] || []
      })
    }

    setCategories(newCategories)

    setAllChecked(isActive)
  }

  return (
    <div className='my-4 space-x-4'>
      <input name='toggle_all' type='checkbox' onChange={toggle} defaultChecked={allChecked} />
      <label htmlFor='toggle_all'>
        <Translation name='inventory.supplier.categories.all_categories' />
      </label>
    </div>
  )
}

export default ToggleAllCategories
